// METHODS

function scrollOnVisibilityAnimate(callback, el, threshold = 0.5) {
  let observer = new IntersectionObserver(
    (entry) => {
      if (entry?.[0]?.isIntersecting) {
        callback();
        observer.unobserve(el);
      }
    },
    {
      rootMargin: "0px",
      threshold,
    }
  );

  observer.observe(el);
}

function scrollCallbackForBG(AnimationInstance, elClass, divideRatio = 800) {
  let el = $(elClass);
  return () => {
    let scrollOffset = window.pageYOffset || window.scrollTop;
    let elOffset = el.offset().top - window.innerHeight;

    let readyScroll = scrollOffset - elOffset;
    if (readyScroll > 0) {
      let scrollDivided = readyScroll / (divideRatio + window.innerHeight);
      AnimationInstance.seek(AnimationInstance.duration * scrollDivided);
    }
  };
}

// INIT CALLBACK SCOPE

$(() => {
  new LazyLoad({
    // use_native: true,
  });

  setContactListener();

  scrollOnVisibilityAnimate(
    () => {
      anime({
        targets: ".case-study",
        opacity: ["0%", "100%"],
        translateY: ["40px", "0"],
        easing: "easeInOutQuad",
        duration: 800,
        delay: anime.stagger(400),
      });
    },
    document.querySelector(".section-case-studies__container"),
    0.4
  );

  scrollOnVisibilityAnimate(
    () => {
      anime({
        targets: ".section-solutions",
        opacity: ["0%", "100%"],
        easing: "easeInOutQuad",
        duration: 800,
      });

      anime({
        targets: ".solution__img",
        opacity: ["0%", "100%"],
        translateY: ["-10px", "0"],
        easing: "easeInOutQuad",
        duration: 800,
        delay: anime.stagger(500, { start: 300 }),
      });
    },
    document.querySelector(".section-solutions__container"),
    0.3
  );

  scrollOnVisibilityAnimate(
    () => {
      anime({
        targets: ".service-item",
        opacity: ["0%", "100%"],
        translateY: ["-10px", "0"],
        easing: "easeInOutQuad",
        duration: 800,
        delay: anime.stagger(500, { start: 300 }),
      });
    },
    document.querySelector(".service-item__container"),
    0.3
  );

  // HERO animations
  anime({
    targets: ".onload-animate-in",
    opacity: ["0%", "100%"],
    translateY: ["-10px", "0"],
    easing: "easeInOutQuad",
    duration: 600,
    delay: anime.stagger(200, { start: 100 }),
  });
  anime({
    targets: ".service__hero-graphics",
    opacity: ["0%", "100%"],
    easing: "easeInOutQuad",
    duration: 800,
    delay: 300,
  });

  // BG animations

  let scrollCallbackHeroGraphic = scrollCallbackForBG(
    anime({
      targets: ".service__hero-graphics",
      translateY: 200,
      rotate: 15,
      autoplay: false,
      easing: "linear",
    }),
    ".section-text h2",
    window.innerHeight
  );

  let scrollCallbackBlueDotLeft = scrollCallbackForBG(
    anime({
      targets: ".bg-graphic--top-left",
      translateY: -90,
      translateX: -45,
      autoplay: false,
      easing: "easeInOutQuad",
    }),
    ".bg-graphic--top-left",
    150 // height of the animation element
  );

  let scrollCallbackBlueDotRight = scrollCallbackForBG(
    anime({
      targets: ".bg-graphic--top-right",
      translateY: -100,
      translateX: 50,
      autoplay: false,
      easing: "easeInOutQuad",
    }),
    ".bg-graphic--top-right",
    150 // height of the animation element
  );

  let scrollCallbackBlueDotMiddle = scrollCallbackForBG(
    anime({
      targets: ".bg-graphic--team img",
      translateY: -160,
      autoplay: false,
      easing: "easeInOutQuad",
    }),
    ".bg-graphic--team img",
    750
  );
  let scrollCallbackFooterNet = scrollCallbackForBG(
    anime({
      targets: ".bg-graphic--footer img",
      translateY: 120,
      autoplay: false,
      easing: "linear",
    }),
    ".navigation-footer",
    window.innerHeight
  );

  scrollCallbackBlueDotLeft();
  scrollCallbackBlueDotRight();
  scrollCallbackBlueDotMiddle();
  scrollCallbackHeroGraphic();
  scrollCallbackFooterNet();

  $(window).on(
    "scroll",
    requestAnimationFrame.bind(null, () => {
      scrollCallbackBlueDotLeft();
      scrollCallbackBlueDotRight();
      scrollCallbackBlueDotMiddle();
      scrollCallbackHeroGraphic();
      scrollCallbackFooterNet();
    })
  );

  // NEED TO PROCESS CODE
  let tabsContainer = document.querySelector(".talent__tabs");
  let tabs = document.querySelectorAll(".talent__tab");
  let tabsContent = document.querySelectorAll(".talent__tab-content");

  tabsContainer.addEventListener("click", (e) => {
    let clicked = e.target.closest(".talent__tab");

    if (!clicked) {
      return;
    }

    // ⭐️ Active Tab ⭐️ //
    tabs.forEach((t) => t.classList.remove("talent__tab--active"));
    clicked.classList.add("talent__tab--active");

    // ⭐️ Active Tab Content ⭐️ //
    tabsContent.forEach((tc) =>
      tc.classList.remove("talent__tab-content--active")
    );
    document
      .querySelector(`.talent__tab-content--${clicked.dataset.tab}`)
      .classList.add("talent__tab-content--active");
  });
});
